<template>
  <div class="clearfix">
    <div class="srh_form_l">{{ label }}</div>
    <div class="srh_form_r">
      <ul>
        <li>
          <label>
            <input
              type="checkbox"
              v-model="allSelected"
              name="all"
              @change="selectAll"
            />
            全選択
          </label>
        </li>
        <li
          v-for="(value, i) in checkboxValues"
          :key="`checkbox${i}`"
        >
          <label>
            <input
              type="checkbox"
              :name="inputName"
              :value="value"
              v-model="selectedValues"
              @change="updateValues"
            />
            {{ replaceFullToHalf(value) }}
          </label>
        </li>
      </ul>
    </div>
  </div>

</template>

<script>
import {defineComponent, computed, ref, watch} from 'vue'

export default defineComponent({
  name: 'CheckboxFormParts',
  props: {
    label: {
      type: String,
      default: '',
      required: true,
    },
    inputName: {
      type: String,
      default: '',
      required: true,
    },
    checkboxValues: {
      type: Array,
      default: () => [],
    },
    selectedBikes: {
      type: Array,
      default: () => [],
    },
  },
  setup(props, { emit }) {
    const replaceFullToHalf = (str) => {
      return str.replace(/[！-～]/g, (s) => {
        // prettier-ignore
        return String.fromCharCode(s.charCodeAt(0) - 0xFEE0)
      }).replace(/　/g,' ')
    }

    const selectedValues = ref([])

    const allSelected = computed({
      get: () => selectedValues.value.length === props.checkboxValues.length,
      set: value => {
        if (value) {
          selectedValues.value = [...props.checkboxValues]
        } else {
          selectedValues.value = []
        }
      }
    })

    const updateValues = () => {
      emit('update:checkboxValues', selectedValues.value)
    }

    const selectAll = () => {
      if (!allSelected.value) {
        selectedValues.value = []
      } else {
        selectedValues.value = [...props.checkboxValues]
      }
      updateValues()
    }

    // selectedBikesの変更を監視
    watch(() => props.selectedBikes, (newValue) => {
      selectedValues.value = JSON.parse(JSON.stringify(newValue))
    })

    return {
      replaceFullToHalf,
      allSelected,
      selectedValues,
      updateValues,
      selectAll,
    }
  },
})

</script>